module.exports = __webpack_public_path__ + "img/mezzo0.d8109491.png";